module.exports = __webpack_public_path__ + "static/media/history_selected.9e7b1076.svg";